import { Component, OnInit, Input } from '@angular/core';
import { TagsSearchItem } from '@app/tags/tags';
/**
 * Skills typeahead item component
 * displays the skill item in the dropdown
 *
 * @param item {TagsSearchItem} item to be displayed
 * @param searchTerm {string} term to highlight in item
 *
 * @example
 * ```
 * <dgx-skill-typeahead-item [item]="suggestion" [searchTerm]="searchTerm"
 * </dgx-skill-typeahead-item
 * ```
 */
@Component({
  selector: 'dgx-skill-typeahead-item',
  templateUrl: './skill-typeahead-item.component.html',
  styleUrls: ['./skill-typeahead-item.component.scss'],
})
export class SkillTypeaheadItemComponent implements OnInit {
  @Input() public item: TagsSearchItem;
  @Input() public searchTerm: string;
  constructor() {}

  public ngOnInit(): void {}
}
